import { useAIAgentThread } from "@/AgentThread/AgentThreadSidebar/AIAgentThreadContext";
import { NewAgentThreadExamples } from "@/AgentThread/AgentThreadSidebar/NewAgentThreadView/NewAgentThreadExamples.tsx";
import { RobotoTypography } from "@/shared/components";
import { AutoAwesomeIcon } from "@/shared/foundation/icons/mui";

import styles from "./NewAgentThreadView.module.css";

const NewAgentThreadLogo = () => {
  return (
    <div className={styles.logoContainer}>
      <div className={styles.logoCircle}>
        <AutoAwesomeIcon className={styles.logoIcon} />
      </div>
      <div className={styles.logoTextContainer}>
        <RobotoTypography className={styles.logoTitle}>Roboto</RobotoTypography>
        <RobotoTypography className={styles.logoSubtitle}>
          (M.D., Ph.D., A.I.)
        </RobotoTypography>
      </div>
    </div>
  );
};

interface NewAgentThreadViewProps {
  onExampleClick: (question: string) => Promise<void>;
}

const NewAgentThreadView = ({ onExampleClick }: NewAgentThreadViewProps) => {
  const { context } = useAIAgentThread();

  const handleExampleClick = (question: string) => {
    void onExampleClick(question);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentContainer}>
        <NewAgentThreadLogo />
        <RobotoTypography className={styles.helpText}>
          How can I help you?
        </RobotoTypography>
      </div>

      <NewAgentThreadExamples
        context={context}
        onExampleClick={handleExampleClick}
      />
    </div>
  );
};

export { NewAgentThreadView };
